/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2243347101d0284063f83cb3084a0b4>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */
import { token } from '@atlaskit/tokens';

export const borderColorMap: {
	'color.border': 'var(--ds-border)';
	'color.border.accent.lime': 'var(--ds-border-accent-lime)';
	'color.border.accent.lime.subtle': 'var(--ds-border-accent-lime-subtle)';
	'color.border.accent.red': 'var(--ds-border-accent-red)';
	'color.border.accent.red.subtle': 'var(--ds-border-accent-red-subtle)';
	'color.border.accent.orange': 'var(--ds-border-accent-orange)';
	'color.border.accent.orange.subtle': 'var(--ds-border-accent-orange-subtle)';
	'color.border.accent.yellow': 'var(--ds-border-accent-yellow)';
	'color.border.accent.yellow.subtle': 'var(--ds-border-accent-yellow-subtle)';
	'color.border.accent.green': 'var(--ds-border-accent-green)';
	'color.border.accent.green.subtle': 'var(--ds-border-accent-green-subtle)';
	'color.border.accent.teal': 'var(--ds-border-accent-teal)';
	'color.border.accent.teal.subtle': 'var(--ds-border-accent-teal-subtle)';
	'color.border.accent.blue': 'var(--ds-border-accent-blue)';
	'color.border.accent.blue.subtle': 'var(--ds-border-accent-blue-subtle)';
	'color.border.accent.purple': 'var(--ds-border-accent-purple)';
	'color.border.accent.purple.subtle': 'var(--ds-border-accent-purple-subtle)';
	'color.border.accent.magenta': 'var(--ds-border-accent-magenta)';
	'color.border.accent.magenta.subtle': 'var(--ds-border-accent-magenta-subtle)';
	'color.border.accent.gray': 'var(--ds-border-accent-gray)';
	'color.border.accent.gray.subtle': 'var(--ds-border-accent-gray-subtle)';
	'color.border.code': 'var(--ds-border-code)';
	'color.border.disabled': 'var(--ds-border-disabled)';
	'color.border.focused': 'var(--ds-border-focused)';
	'color.border.input': 'var(--ds-border-input)';
	'color.border.inverse': 'var(--ds-border-inverse)';
	'color.border.selected': 'var(--ds-border-selected)';
	'color.border.brand': 'var(--ds-border-brand)';
	'color.border.danger': 'var(--ds-border-danger)';
	'color.border.danger.subtle': 'var(--ds-border-danger-subtle)';
	'color.border.warning': 'var(--ds-border-warning)';
	'color.border.warning.subtle': 'var(--ds-border-warning-subtle)';
	'color.border.success': 'var(--ds-border-success)';
	'color.border.success.subtle': 'var(--ds-border-success-subtle)';
	'color.border.discovery': 'var(--ds-border-discovery)';
	'color.border.discovery.subtle': 'var(--ds-border-discovery-subtle)';
	'color.border.information': 'var(--ds-border-information)';
	'color.border.information.subtle': 'var(--ds-border-information-subtle)';
	'color.border.bold': 'var(--ds-border-bold)';
} = {
	'color.border': token('color.border', '#0B120E24'),
	'color.border.accent.lime': token('color.border.accent.lime', '#6A9A23'),
	'color.border.accent.lime.subtle': token('color.border.accent.lime.subtle', '#B3DF72'),
	'color.border.accent.red': token('color.border.accent.red', '#E2483D'),
	'color.border.accent.red.subtle': token('color.border.accent.red.subtle', '#FD9891'),
	'color.border.accent.orange': token('color.border.accent.orange', '#E06C00'),
	'color.border.accent.orange.subtle': token('color.border.accent.orange.subtle', '#FBC828'),
	'color.border.accent.yellow': token('color.border.accent.yellow', '#B38600'),
	'color.border.accent.yellow.subtle': token('color.border.accent.yellow.subtle', '#EED12B'),
	'color.border.accent.green': token('color.border.accent.green', '#22A06B'),
	'color.border.accent.green.subtle': token('color.border.accent.green.subtle', '#7EE2B8'),
	'color.border.accent.teal': token('color.border.accent.teal', '#2898BD'),
	'color.border.accent.teal.subtle': token('color.border.accent.teal.subtle', '#9DD9EE'),
	'color.border.accent.blue': token('color.border.accent.blue', '#357DE8'),
	'color.border.accent.blue.subtle': token('color.border.accent.blue.subtle', '#8FB8F6'),
	'color.border.accent.purple': token('color.border.accent.purple', '#AF59E1'),
	'color.border.accent.purple.subtle': token('color.border.accent.purple.subtle', '#D8A0F7'),
	'color.border.accent.magenta': token('color.border.accent.magenta', '#CD519D'),
	'color.border.accent.magenta.subtle': token('color.border.accent.magenta.subtle', '#F797D2'),
	'color.border.accent.gray': token('color.border.accent.gray', '#7D818A'),
	'color.border.accent.gray.subtle': token('color.border.accent.gray.subtle', '#B7B9BE'),
	'color.border.code': token('color.border.code', '#0B120E24'),
	'color.border.disabled': token('color.border.disabled', '#0515240F'),
	'color.border.focused': token('color.border.focused', '#4688EC'),
	'color.border.input': token('color.border.input', '#8C8F97'),
	'color.border.inverse': token('color.border.inverse', '#FFFFFF'),
	'color.border.selected': token('color.border.selected', '#1868DB'),
	'color.border.brand': token('color.border.brand', '#1868DB'),
	'color.border.danger': token('color.border.danger', '#E2483D'),
	'color.border.danger.subtle': token('color.border.danger.subtle', '#FD9891'),
	'color.border.warning': token('color.border.warning', '#E06C00'),
	'color.border.warning.subtle': token('color.border.warning.subtle', '#FBC828'),
	'color.border.success': token('color.border.success', '#6A9A23'),
	'color.border.success.subtle': token('color.border.success.subtle', '#B3DF72'),
	'color.border.discovery': token('color.border.discovery', '#AF59E1'),
	'color.border.discovery.subtle': token('color.border.discovery.subtle', '#D8A0F7'),
	'color.border.information': token('color.border.information', '#357DE8'),
	'color.border.information.subtle': token('color.border.information.subtle', '#8FB8F6'),
	'color.border.bold': token('color.border.bold', '#7D818A'),
} as const;

export type BorderColor = keyof typeof borderColorMap;
